import React from "react";
type ModuleProps = {
  number: string;
  title: string;
  description: string;
  index: number;
};
const Module: React.FC<ModuleProps> = ({
  number,
  title,
  description,
  index
}) => {
  return <div className="group relative">
      {/* Card glow effect */}
      <div className="absolute -inset-1 bg-gradient-to-r from-tagblue to-tagblue-light rounded-3xl blur-2xl opacity-25 group-hover:opacity-50 transition-opacity duration-500" />
      
      {/* Main card */}
      <div className="relative bg-white/80 backdrop-blur-md rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-500 border border-white/50 group-hover:scale-105 transform h-full">
        {/* Floating 3D elements */}
        <div className="absolute -top-2 -right-2 w-6 h-6 bg-tagblue/20 rounded-lg rotate-45 animate-float opacity-0 group-hover:opacity-100 transition-opacity" />
        
        {/* Number with gradient background */}
        <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-tagblue to-tagblue-dark rounded-2xl shadow-lg mb-6">
          <span className="text-2xl font-bold text-white">{number}</span>
        </div>
        
        <h3 className="text-xl font-bold mb-4 text-gray-900 group-hover:text-tagblue transition-colors duration-300">
          {title}
        </h3>
        
        <p className="text-gray-600 leading-relaxed">
          {description}
        </p>
        
        {/* Decorative bottom accent */}
        <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-16 h-1 bg-gradient-to-r from-tagblue to-tagblue-light rounded-full opacity-60" />
      </div>
    </div>;
};
const FrameworkModules: React.FC = () => {
  const modules = [{
    number: "01",
    title: "TDM licensing",
    description: "Licensing module describing best practices to follow and threats to prevent"
  }, {
    number: "02",
    title: "Attribution & Royalty",
    description: "Attribution module exploring the technicalities of 'inspiration' attribution"
  }, {
    number: "03",
    title: "Opt-ins & Opt-outs",
    description: "Establishing technical requirements & challenges for AI opt-in & opt-outs"
  }, {
    number: "04",
    title: "Ethical Certifications",
    description: "Best practices for certifying AI companies, products and their outputs as Ethical"
  }, {
    number: "05",
    title: "Copyrightability",
    description: "The core of everything, we explored various challenges overlooking Human & AI overlap"
  }, {
    number: "06",
    title: "AI Inclusion - Intentional usage",
    description: "If AI is used by an artist and the reports the same, best practices for its regulation"
  }, {
    number: "07",
    title: "AI Music Detection",
    description: "Legal considerations and compliance requirements"
  }, {
    number: "08",
    title: "AI likeness license",
    description: "Personality rights & voice/style protection"
  }, {
    number: "09",
    title: "AI Output tracking",
    description: "Strategic vision for integrating Music tagging & provenance solutions"
  }];
  return <div className="py-20 bg-gradient-to-br from-gray-50 via-blue-50/30 to-gray-100 relative overflow-hidden">
      {/* Enhanced 3D Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-10 right-10 w-24 h-24 bg-tagblue/10 rounded-full blur-xl animate-float" />
        <div className="absolute bottom-10 left-10 w-32 h-32 bg-tagblue-light/10 rounded-full blur-xl animate-float" style={{
        animationDelay: '3s'
      }} />
        <div className="absolute top-32 left-20 w-20 h-20 bg-tagblue/15 rounded-3xl backdrop-blur-sm rotate-12 animate-float" style={{
        animationDelay: '1s'
      }} />
        <div className="absolute bottom-32 right-20 w-16 h-16 bg-tagblue-light/15 rounded-2xl backdrop-blur-sm -rotate-12 animate-float" style={{
        animationDelay: '2s'
      }} />
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-gray-900 via-tagblue to-gray-900 text-5xl">
              Framework Modules
            </span>
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto font-normal text-xl">
            Comprehensive modules covering all aspects of AI music transparency and compliance
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {modules.map((module, index) => <Module key={index} number={module.number} title={module.title} description={module.description} index={index} />)}
        </div>
      </div>
    </div>;
};
export default FrameworkModules;